import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

export const getVehicles = createAsyncThunk('get/vehicle', async () => {
  const response = await axios.get('/vehicle/');
  return response.data;
});

export const addVehicle = createAsyncThunk('add/vehicle', async (vehicle, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/vehicle/', vehicle);
    dispatch(getVehicles());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateVehicle = createAsyncThunk(
  'update/vehicle',
  async ({ idVehicle, vehicle }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/vehicle/${idVehicle}/`, vehicle);
      dispatch(getVehicles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteVehicle = createAsyncThunk('delete/vehicle', async (idVehicle, { rejectWithValue }) => {
  try {
    const response = await axios.delete(`/vehicle/${idVehicle}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyVehicles = createAsyncThunk(
  'deleteMany/vehicle',
  async (vehicleIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/vehicle/delete_many/', { data: { arrId: vehicleIDs } });
      dispatch(getVehicles());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const vehicleAdapter = createEntityAdapter({});

const vehicleSlice = createSlice({
  name: 'vehicles',
  initialState: vehicleAdapter.getInitialState({
    vehicles: [],
    searchText: '',
    routeParams: {},
    loading: false,
    isSubmitting: false,
  }),
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: {
    [getVehicles.pending]: (state) => {
      state.loading = true;
    },
    [getVehicles.fulfilled]: (state, action) => {
      state.vehicles = action.payload.data;
      state.loading = false;
    },
    [getVehicles.rejected]: (state) => {
      state.loading = false;
    },
    [addVehicle.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addVehicle.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.vehicles = data;
      state.isSubmitting = false;
    },
    [addVehicle.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [updateVehicle.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateVehicle.fulfilled]: (state, action) => {
      const index = state.vehicles.findIndex((item) => item.id === action.payload.id);
      state.vehicles[index] = {
        ...state.vehicles[index],
        ...action.payload.data,
      };
    },
    [updateVehicle.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [deleteVehicle.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteVehicle.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteVehicle.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyVehicles.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyVehicles.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyVehicles.rejected]: (state) => {
      state.isSubmitting = false;
    },
  },
});

export const { setSearchText } = vehicleSlice.actions;

export default vehicleSlice.reducer;
